import ContactForm from './ContactForm';

export default function ServiceFlow() {
  const steps = [
    {
      number: '01',
      title: 'お申込み',
      description: '申込フォームよりご依頼ください',
      icon: 'ri-file-edit-line',
      color: 'from-[#eb4b3f] to-[#f0945b]'
    },
    {
      number: '02',
      title: '文献調査・検索',
      description: '専門のサーチャーが迅速に調査いたします',
      icon: 'ri-search-line',
      color: 'from-[#f0945b] to-[#eb4b3f]'
    },
    {
      number: '03',
      title: '結果のお届け',
      description: 'メールで検索結果リストをお届けします',
      icon: 'ri-mail-send-line',
      color: 'from-[#eb4b3f] to-[#f0945b]'
    },
    {
      number: '04',
      title: '複写のご依頼',
      description: '必要な文献の複写をご依頼いただけます',
      icon: 'ri-file-copy-line',
      color: 'from-[#f0945b] to-[#eb4b3f]'
    }
  ];

  return (
    <section id="flow" className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">サービスご利用の流れ</h2>
          <p className="text-lg text-gray-600">
            簡単4ステップで文献検索サービスをご利用いただけます
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-20 left-full w-full h-0.5 bg-gradient-to-r from-[#f0945b] to-transparent -translate-x-4 z-0"></div>
              )}
              
              <div className="relative bg-white rounded-2xl shadow-lg p-8 border border-gray-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-2 h-full">
                <div className="text-center">
                  <div className={`inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br ${step.color} rounded-full mb-6 shadow-lg`}>
                    <i className={`${step.icon} text-3xl text-white`}></i>
                  </div>
                  
                  <div className="mb-4">
                    <span className={`inline-block text-5xl font-bold bg-gradient-to-br ${step.color} bg-clip-text text-transparent`}>
                      {step.number}
                    </span>
                  </div>
                  
                  <h3 className="text-xl font-bold text-gray-800 mb-3">{step.title}</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">{step.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <ContactForm />
        </div>
      </div>
    </section>
  );
}
